import { throttle } from 'throttle-debounce';

export default () => {
  const slideNumber = 4;
  const throttleBy = 300;
  const prevArrowAttrValue = 'prev';
  const nextArrowAttrValue = 'next';

  const rootSelector = '[data-carousel-360]';
  const rootActiveSlideAttrName = 'data-carousel-360-active-slide';
  const rootElement = $(rootSelector);

  const dotsButtonSelector = '[data-carousel-360-button]';
  const dotsButtonAttrName = 'data-carousel-360-button';
  const dotsButtonElementArray = $(dotsButtonSelector);

  const arrowButtonSelector = '[data-carousel-360-arrow]';
  const arrowButtonAttrName = 'data-carousel-360-arrow';
  const arrowButtonElementArray = $(arrowButtonSelector);
  
  /**
   * Callbacks 
   */
  const changeActiveSlideTo = throttle(throttleBy, (slideID) => {
    rootElement.attr(rootActiveSlideAttrName, slideID);
  });

  const prevSlideCallback = () => {
    const rootActiveSlideAttrValue = parseInt(rootElement.attr(rootActiveSlideAttrName));
    const nextSlideID = rootActiveSlideAttrValue === 1 ? slideNumber : rootActiveSlideAttrValue - 1;
    changeActiveSlideTo(nextSlideID);
  }

  const nextSlideCallback = () => {
    const rootActiveSlideAttrValue = parseInt(rootElement.attr(rootActiveSlideAttrName));
    const nextSlideID =  rootActiveSlideAttrValue % slideNumber === 0 ? 1 : rootActiveSlideAttrValue + 1;
    changeActiveSlideTo(nextSlideID);
  }

  /**
   * Events setup
   */
  dotsButtonElementArray.click(function() {
    const dotsButtonElement = $(this);
    const dotsButtonAttrValue = dotsButtonElement.attr(dotsButtonAttrName);
    changeActiveSlideTo(dotsButtonAttrValue);
  });

  arrowButtonElementArray.click(function() {
    const arrowButtonElement = $(this);
    const arrowButtonAttrValue = arrowButtonElement.attr(arrowButtonAttrName);
    switch (arrowButtonAttrValue) {
      case prevArrowAttrValue:
        return prevSlideCallback();
      case nextArrowAttrValue:
        return nextSlideCallback();
    }
  });

  rootElement.swipeleft(prevSlideCallback);
  rootElement.swiperight(nextSlideCallback);
};
